import { ReactNode } from 'react';
import { MetadataKey, MetadataList, MetadataRow, MetadataValue } from './styles';

type Props = {
    metadata: Record<string, ReactNode>;
};

const Metadata = ({ metadata }: Props) => {
    return (
        <MetadataList>
            {Object.entries(metadata).map(([key, value]) => (
                <MetadataRow key={key}>
                    <MetadataKey>{key}:</MetadataKey>
                    <MetadataValue>{value}</MetadataValue>
                </MetadataRow>
            ))}
        </MetadataList>
    );
};

export default Metadata;
